import { defineStore } from "pinia";

export const useBoardConfigStore = defineStore("boardConfig", {
  state: () => ({ active: false }),
  actions: {
    toggle(active?: boolean) {
      this.active = active ?? !this.active;
    },
  },
});
